import {Component, EventEmitter, Input, OnInit, Output, OnDestroy} from '@angular/core';
import {NOME_DO_SEGMENTO, SEGMENTOS_TODOS} from "../../../../server/lib/emun/EnumStatusContato";
import {SEGMENTOS_CRM} from "../../fidelidade/crm/crm-segmentos";
import {EmpresasService} from "../../superadmin/services/empresas.service";
import {FiltroTelaUI} from "../../../../projects/loja/src/objeto/FiltroTelaUI";

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'filtro-avancado',
  templateUrl: './filtro-avancado.component.html',
  styleUrls: ['./filtro-avancado.component.scss'],
  host: {
    '[class.visible]': 'exibir'
  }
})
export class FiltroAvancadoComponent implements OnInit, OnDestroy {
  @Output() onVoltar = new EventEmitter();
  @Output() onFiltrar = new EventEmitter();
  @Output() onFechar = new EventEmitter();

  @Input() set exibir(value: boolean) {
    this._exibir = value;
    if (value) {
      document.body.classList.add('filtro-aberto');
    } else {
      document.body.classList.remove('filtro-aberto');
    }
  }
  get exibir(): boolean {
    return this._exibir;
  }

  private _exibir: boolean;
  tags = []
  filtro: any = {};
  sexos = [ { value: 'Homem', label: 'Homem'}, { value: 'Mulher', label: 'Mulher' } ];
  planos = [  ];
  valores: any = [];
  unidades = FiltroTelaUI.getUnidades();
  operadores = FiltroTelaUI.getOperadores();
  operadoresMais = FiltroTelaUI.getOperadoresMais();
  tiposClientes: any = [];
  tiposPets: any  = [];
  generosPets: any = ['Macho', "Fêmea"];
  classificacoes: any = [
    { value: 'ESFRIANDO', label: 'Esfriando' },
    { value: 'SUMIDO', label: 'Sumidos' },
    { value: 'NOVO', label: 'Novos' },
    { value: 'FIEL', label: 'Fiéis' },
    { value: 'CAMPEAO', label: 'Campeões' },
    { value: 'PERDIDO', label: 'Perdidos' },
    { value: 'SEM_PEDIDO', label: 'Sem pedido' }
  ];
  /** Faixas do CRM editadas na tela; viram "min,max" no filtro ao aplicar. */
  readonly faixasCrm = [
    {chave: 'crmDiasSemPedir', rotulo: 'Dias sem pedir', unidade: 'dias', prefixo: ''},
    {chave: 'crmPedidos90d', rotulo: 'Pedidos em 90 dias', unidade: 'pedidos', prefixo: ''},
    {chave: 'crmGasto90d', rotulo: 'Gasto em 90 dias', unidade: '', prefixo: 'R$'},
    {chave: 'crmTicket90d', rotulo: 'Ticket médio em 90 dias', unidade: '', prefixo: 'R$'},
    {chave: 'crmTotalPedidos', rotulo: 'Pedidos no histórico', unidade: 'pedidos', prefixo: ''},
    {chave: 'crmCiclo', rotulo: 'Pede a cada', unidade: 'dias', prefixo: ''},
  ];
  readonly diasDaSemana = FiltroTelaUI.DIAS_DA_SEMANA;
  readonly segmentosCrm = SEGMENTOS_CRM;
  crm: {faixas: {[chave: string]: {min: any; max: any}}; dias: boolean[]; produto: string; mudouHaDias: any} = this.crmVazio();

  constructor(private empresaService: EmpresasService) {
    this.setNovoFiltro();
  }

  ngOnInit() {
    this.tiposClientes = [];
    for (const status of SEGMENTOS_TODOS) {
      this.tiposClientes.push({ label: NOME_DO_SEGMENTO[status], value: status });
    }
    for(let i = 1; i <= 90; i++)
      this.valores.push( { value: i, label: i + ''} );

    this.empresaService.listeTiposPet( ).then( tipos => this.tiposPets = tipos);

    this.empresaService.listeTags().then( tags =>  this.setTags(tags) )

  }

  ngOnDestroy() {
    document.body.classList.remove('filtro-aberto');
  }

  setNovoFiltro() {
    this.filtro = {
      ultimas: FiltroTelaUI.ultimaCompra(),
      pontuacao: FiltroTelaUI.pontuacao(),
      ticketMedio: FiltroTelaUI.ticketMedio(),
      totalComprado: FiltroTelaUI.totalComprado(),
      qtdComprado: FiltroTelaUI.qtdeCompras(),
      qtdVisitas: FiltroTelaUI.qtdVisitas(),
      naoNotificado: FiltroTelaUI.naoNotificado(),
      aniversario: FiltroTelaUI.aniversario(),
      status: FiltroTelaUI.status(),
      plano: FiltroTelaUI.plano(),
      tag: FiltroTelaUI.tag(),
      jaTrocou: FiltroTelaUI.jaTrocou(),
      podeTrocar: FiltroTelaUI.podeTrocar(),
      sexo: FiltroTelaUI.sexo(),
      tipoPet: FiltroTelaUI.tipoPet(),
      generoPet: FiltroTelaUI.generoPet(),
      apenasDddLocal: FiltroTelaUI.apenasDddLocal(),
      crmDiasSemPedir: FiltroTelaUI.crmDiasSemPedir(),
      crmPedidos90d: FiltroTelaUI.crmPedidos90d(),
      crmGasto90d: FiltroTelaUI.crmGasto90d(),
      crmTicket90d: FiltroTelaUI.crmTicket90d(),
      crmTotalPedidos: FiltroTelaUI.crmTotalPedidos(),
      crmCiclo: FiltroTelaUI.crmCiclo(),
      crmProdutoFavorito: FiltroTelaUI.crmProdutoFavorito(),
      crmDiasSemana: FiltroTelaUI.crmDiasSemana(),
      crmMudouHaDias: FiltroTelaUI.crmMudouHaDias(),
      crmSegmentoAnterior: FiltroTelaUI.crmSegmentoAnterior(),
      crmRecebeCampanha: FiltroTelaUI.crmRecebeCampanha()
    }
    this.crm = this.crmVazio();


    this.filtro.naoNotificado.operador = this.operadoresMais[0];
  }

  voltar() {
    this.onVoltar.emit({})
  }

  vaiUsarFiltro(filtroAvancado, valores, unidades) {
    if(filtroAvancado.operador && valores && unidades){
      filtroAvancado.valor = valores[0];
      filtroAvancado.unidade = unidades[0];
    }
  }

  setFiltroAvancado(dados) {
    this.setNovoFiltro();

    for(let chave in dados){
      if(dados[chave] && dados[chave].id)
         this.setFiltroExistente(dados[chave])
      else  {
        this.filtro[chave] = dados[chave];
      }
    }
    this.leiaCrmDoFiltro();
  }

  private crmVazio() {
    const faixas: {[chave: string]: {min: any; max: any}} = {};
    (this.faixasCrm || []).forEach(f => faixas[f.chave] = {min: null, max: null});
    return {faixas, dias: [false, false, false, false, false, false, false], produto: '', mudouHaDias: null};
  }

  private vazio(v: any): boolean {
    return v === null || v === undefined || String(v).trim() === '';
  }

  /** Tela -> filtros: só vira filtro o que foi preenchido. */
  private escrevaCrmNoFiltro() {
    this.faixasCrm.forEach(f => {
      const faixa = this.crm.faixas[f.chave];
      this.filtro[f.chave].valor = this.vazio(faixa.min) && this.vazio(faixa.max) ? null
        : `${this.vazio(faixa.min) ? '' : faixa.min},${this.vazio(faixa.max) ? '' : faixa.max}`;
    });
    const dias = this.crm.dias.map((marcado, i) => marcado ? i : null).filter(i => i !== null);
    this.filtro.crmDiasSemana.valor = dias.length ? dias.join(',') : null;
    this.filtro.crmProdutoFavorito.valor = this.vazio(this.crm.produto) ? null : String(this.crm.produto).trim();
    this.filtro.crmMudouHaDias.valor = this.vazio(this.crm.mudouHaDias) ? null : Number(this.crm.mudouHaDias);
    if (this.filtro.crmSegmentoAnterior.valor && !this.filtro.crmSegmentoAnterior.valor.length) this.filtro.crmSegmentoAnterior.valor = null;
    if (!this.filtro.crmRecebeCampanha.valor) this.filtro.crmRecebeCampanha.valor = null;
  }

  /** Filtro salvo -> tela. */
  private leiaCrmDoFiltro() {
    this.crm = this.crmVazio();
    this.faixasCrm.forEach(f => {
      const valor = this.filtro[f.chave] && this.filtro[f.chave].valor;
      if (this.vazio(valor)) return;
      const [min, max] = String(valor).split(',');
      this.crm.faixas[f.chave] = {min: this.vazio(min) ? null : Number(min), max: this.vazio(max) ? null : Number(max)};
    });
    const dias = this.filtro.crmDiasSemana.valor;
    if (!this.vazio(dias)) String(dias).split(',').forEach(d => this.crm.dias[Number(d)] = true);
    this.crm.produto = this.filtro.crmProdutoFavorito.valor || '';
    this.crm.mudouHaDias = this.filtro.crmMudouHaDias.valor;
  }

  alterneLista(filtro: any, codigo: string) {
    const atual: string[] = Array.isArray(filtro.valor) ? filtro.valor : [];
    filtro.valor = atual.indexOf(codigo) >= 0 ? atual.filter(c => c !== codigo) : [...atual, codigo];
  }

  estaNaLista(filtro: any, codigo: string): boolean {
    return Array.isArray(filtro.valor) && filtro.valor.indexOf(codigo) >= 0;
  }

  setFiltroExistente(filtro){
    for(let chave in this.filtro){
      if(this.filtro[chave].id === filtro.id) {
        this.filtro[chave].valor = filtro.valor;
        this.filtro[chave].operador = filtro.operador;
        this.filtro[chave].unidade = filtro.unidade;
      }
    }
  }

  filtre(){
    this.escrevaCrmNoFiltro();
    let dados = {};

    // tslint:disable-next-line:forin
    for ( let key in this.filtro ) {
      let filtro = this.filtro[key];

      if( filtro.id ) {
        let valor =  FiltroTelaUI.getValor(filtro)

        if(valor != null) dados[key] = filtro;
      } else {
        dados[key] = filtro;
      }
    }

    this.onFiltrar.emit(dados);
  }

  setTags(tags){
    tags.forEach(  (tag) => {
      this.tags.push( { value: tag.id, label: tag.nome } )
    })
  }

  setPlanos(planos: any[]) {
    this.planos = [ { value: 0, label: 'Todos' } ];

    planos.forEach(  (plano) => {
      this.planos.push( { value: plano.id, label: plano.nome } )
    })
  }
}
